module.exports = __webpack_public_path__ + "static/017-slideshow-a57ff22a07c82a28f36b854708f680ad.jpg";